import { render, staticRenderFns } from "./EditableColumnTypeText.vue?vue&type=template&id=3d806733&scoped=true&"
import script from "./EditableColumnTypeText.vue?vue&type=script&lang=js&"
export * from "./EditableColumnTypeText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d806733",
  null
  
)

export default component.exports